var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce-containerty",style:({width:_vm.containerWidth})},[_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId},on:{"change":_vm.ada}})])}
var staticRenderFns = []

export { render, staticRenderFns }